
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flights/[...all]",
      function () {
        return require("private-next-pages/flights/[...all].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flights/[...all]"])
      });
    }
  